import { Field as BaseField, type FieldDescriptionProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { descriptionStyle } from './CheckboxDescription.css';

type Props = FieldDescriptionProps;

export const CheckboxDescription = ({ ...delegated }: Props) => {
  return <BaseField.Description {...delegated} className={clsxs(descriptionStyle, delegated.className)} render={<span />} />;
};
